import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

interface PdfPaperEntry {
  title: string;
  doi: string | null;
  authors: string[];
  year: number | null;
  filename: string;
}

interface PdfPaperResult {
  filename: string;
  paper_id: string;
  title: string;
  resolved: boolean;
}

interface PdfPapersResponse {
  results: PdfPaperResult[];
  added: number;
  duplicates: number;
  merged: number;
}

export function usePdfPaperImport(conceptId: string) {
  const queryClient = useQueryClient();

  const createPapersFromPdfs = useCallback(
    async (
      entries: PdfPaperEntry[],
      role: "foundational" | "trawled" = "trawled",
      rightsAttestation = false,
    ): Promise<PdfPapersResponse> => {
      const res = await apiClient
        .post(`api/concepts/${conceptId}/import/pdf-papers`, {
          json: { papers: entries, role, rights_attestation: rightsAttestation },
          timeout: 120_000,
        })
        .json<PdfPapersResponse>();

      await queryClient.invalidateQueries({
        queryKey: ["papers", conceptId],
      });

      return res;
    },
    [conceptId, queryClient],
  );

  return { createPapersFromPdfs };
}
